<template>
  <div class="quote__list-insured">
    <div class="quote__accordion">
      <BaseAccordion>
        <template v-slot:name>
          {{ header }}
          <div class="quote__list-counter">{{ counterString }}</div>
        </template>
        <template v-slot:content>
          <slot name="insuredList">
          </slot>
        </template>
      </BaseAccordion>
    </div>
  </div>
</template>

<script>
import BaseAccordion from '../BaseAccordion.vue'
export default {
  name: 'QuoteInsuredList',
  components: {
    BaseAccordion
  },
  props: {
    header: { type: String },
    counter: { type: Number },
    for: { type: String, default: 'member' }
  },
  computed: {
    counterString () {
      if (this.for === 'member') {
        return this.counter > 1
          ? this.$t('qic_quote_for_people', { counter: this.counter })
          : this.$t('qic_quote_for_person')
      }
      return this.$tc('qic_quote_for_items', this.counter, { counter: this.counter })
    }
  }
}
</script>
